import React from 'react';

import FaqPage from '../components/FaqPage';

const FAQ = () => (
  <FaqPage
    lang="en"
    title="FAQ | COMP 227"
    seoDescription="Frequently asked questions"
  />
);

export default FAQ;
